<ng-scrollbar class="w-full flex flex-col max-h-[100%]" [visibility]="'hover'" [autoHeightDisabled]="false">
  <div class="w-full flex p-6">
    <palantir-banner variant="info" theme="default" class="w-full">
      <palantir-icon name="launch-filled"></palantir-icon>
      <palantir-text type="description">
        {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INFO' | translate }}
      </palantir-text>
    </palantir-banner>
  </div>
  @if (isLoading()) {
    <div class="w-full ga-3 p-6 flex flex-col gap-3">
      <palantir-skeleton class="w-full h-72 rounded-lg"></palantir-skeleton>
      <palantir-skeleton class="w-full h-72 rounded-lg"></palantir-skeleton>
      <palantir-skeleton class="w-full h-72 rounded-lg"></palantir-skeleton>
      <palantir-skeleton class="w-full h-72 rounded-lg"></palantir-skeleton>
      <palantir-skeleton class="w-full h-72 rounded-lg"></palantir-skeleton>
    </div>
  } @else if (warranties().length) {
    <div class="w-full ga-3 p-6 flex flex-col gap-3">
      <div class="flex items-center justify-between pb-3">
        <palantir-text type="title" size="lg">
          {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.TITLE' | translate: { quantity: warranties().length } }}
        </palantir-text>
        @if (hasCreateWarrantyPermission) {
          <palantir-button size="2xs" (click)="openDialog()" theme="outline" layout="prefix" icon="add-outline">
            {{ 'TAB_WARRANTIES_EQUIPMENT.BUTTON.ADD' | translate }}</palantir-button
          >
        }
      </div>
      @for (warranty of warranties(); track warranty; let i = $index) {
        @let isViewMode = editingIndex() !== i; @let hasCoverageExtend = forms[i].get('hasCoverageExtend')?.value;

        <palantir-accordion [warranty]="warranty">
          <div class="flex flex-col gap-2">
            <div class="w-full grid grid-cols-2">
              <palantir-input [label]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.VALUE' | translate">
                @if (isViewMode) {
                  <palantir-text type="title">
                    {{ warranty.value | currencyFormat }}
                  </palantir-text>
                } @else {
                  <input type="text" [formControl]="forms[i] | getControl: 'value'" currencyMask />
                }
                <palantir-input-error>
                  @if (forms[i].get('value')?.hasError('required')) {
                    <palantir-text type="negative" size="xs">
                      {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.REQUIRED' | translate }}
                    </palantir-text>
                  }
                  @if (forms[i].get('value')?.hasError('min')) {
                    <palantir-text type="negative" size="xs">
                      {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.VALUE_MIN' | translate: { value: 0 } }}
                    </palantir-text>
                  }
                  @if (forms[i].get('value')?.hasError('max')) {
                    <palantir-text type="negative" size="xs">
                      {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.MAX' | translate }}
                    </palantir-text>
                  }
                </palantir-input-error>
              </palantir-input>

              <palantir-input [label]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.CONVERAGE_DAYS' | translate">
                @if (isViewMode) {
                  <palantir-text type="title">
                    {{ warranty.coverageDurationDays }}
                    {{ 'TAB_WARRANTIES_EQUIPMENT.DIALOG.DAYS' | translate }}
                  </palantir-text>
                } @else {
                  <input [formControl]="forms[i] | getControl: 'coverageDurationDays'" type="number" min="0" />
                }
                <palantir-input-error>
                  @if (forms[i].get('coverageDurationDays')?.hasError('required')) {
                    <palantir-text type="negative" size="xs">
                      {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.REQUIRED' | translate }}
                    </palantir-text>
                  }
                  @if (forms[i].get('coverageDurationDays')?.hasError('min')) {
                    <palantir-text type="negative" size="xs">
                      {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.DAY_MIN' | translate: { days: 1 } }}
                    </palantir-text>
                  }
                  @if (forms[i].get('coverageDurationDays')?.hasError('max')) {
                    <palantir-text type="negative" size="xs">
                      {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.MAX' | translate }}
                    </palantir-text>
                  }
                </palantir-input-error>
              </palantir-input>

              <palantir-input [label]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.START_DATE' | translate">
                <palantir-text type="title">
                  {{ warranty.startDate | date: 'dd/MM/yyyy' }}
                </palantir-text>
              </palantir-input>

              <palantir-input [label]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.END_DATE' | translate">
                <palantir-text type="title">
                  {{ forms[i].get('coverageEndedAt')?.value | date: 'dd/MM/yyyy' }}
                </palantir-text>
              </palantir-input>
            </div>
            <palantir-layout class="w-full p-3 card">
              <div class="flex items-center gap-2">
                <palantir-icon name="warranty-outline"></palantir-icon>
                <palantir-text type="title">
                  {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.WARRANTY_EXTENDED' | translate }}
                </palantir-text>
              </div>
              @if (!isViewMode) {
                <palantir-input
                  cdkListbox
                  [cdkListboxValue]="[forms[i].get('hasCoverageExtend')?.value]"
                  (cdkListboxValueChange)="forms[i].get('hasCoverageExtend')?.setValue($event.value[0])"
                >
                  <div class="flex gap-3 p-2">
                    <palantir-radio [cdkOption]="false" label="{{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.DISABLE' | translate }}">
                    </palantir-radio>
                    <palantir-radio [cdkOption]="true" label="{{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.ENABLE' | translate }}">
                    </palantir-radio>
                  </div>
                </palantir-input>
              }
              @if (hasCoverageExtend) {
                <div class="w-full grid grid-cols-2">
                  <palantir-input [label]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.EXTENDED_VALUE' | translate">
                    @if (isViewMode) {
                      <palantir-text type="title">
                        {{ warranty.extendedValue | currencyFormat }}
                      </palantir-text>
                    } @else {
                      <input type="text" [formControl]="forms[i] | getControl: 'extendedValue'" currencyMask />
                    }
                    <palantir-input-error>
                      @if (forms[i].get('extendedValue')?.hasError('required')) {
                        <palantir-text type="negative" size="xs">
                          {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.REQUIRED' | translate }}
                        </palantir-text>
                      }
                      @if (forms[i].get('extendedValue')?.hasError('min')) {
                        <palantir-text type="negative" size="xs">
                          {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.VALUE_MIN' | translate: { value: 1 } }}
                        </palantir-text>
                      }
                      @if (forms[i].get('extendedValue')?.hasError('max')) {
                        <palantir-text type="negative" size="xs">
                          {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.MAX' | translate }}
                        </palantir-text>
                      }
                    </palantir-input-error>
                  </palantir-input>

                  <palantir-input [label]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.EXTENDED_CONVERAGE_DAYS' | translate">
                    @if (isViewMode) {
                      <palantir-text type="title">
                        {{ warranty.extendedCoverageDurationDays }}
                      </palantir-text>
                    } @else {
                      <input [formControl]="forms[i] | getControl: 'extendedCoverageDurationDays'" type="number" min="0" />
                    }
                    <palantir-input-error>
                      @if (forms[i].get('extendedCoverageDurationDays')?.hasError('required')) {
                        <palantir-text type="negative" size="xs">
                          {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.REQUIRED' | translate }}
                        </palantir-text>
                      }
                      @if (forms[i].get('extendedCoverageDurationDays')?.hasError('min')) {
                        <palantir-text type="negative" size="xs">
                          {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.DAY_MIN' | translate: { days: 1 } }}
                        </palantir-text>
                      }
                      @if (forms[i].get('extendedCoverageDurationDays')?.hasError('max')) {
                        <palantir-text type="negative" size="xs">
                          {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.MAX' | translate }}
                        </palantir-text>
                      }
                    </palantir-input-error>
                  </palantir-input>

                  <palantir-input [label]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.START_DATE' | translate">
                    <palantir-text type="title">
                      {{ forms[i].get('coverageEndedAt')?.value | date: 'dd/MM/yyyy' }}
                    </palantir-text>
                  </palantir-input>

                  <palantir-input [label]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.END_DATE' | translate">
                    <palantir-text type="title">
                      {{ forms[i].get('extendedCoverageEndedAt')?.value | date: 'dd/MM/yyyy' }}
                    </palantir-text>
                  </palantir-input>
                </div>
              } @else {
                <div class="flex justify-center">
                  <palantir-text type="description">
                    {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.NO_EXTENDED' | translate }}
                  </palantir-text>
                </div>
              }
            </palantir-layout>
            <div>
              <palantir-input [label]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.MAINTENANCE_TYPE' | translate">
                <palantir-text type="title">
                  @let maintenanceTypes = forms[i].get('maintenancesTypes')?.value;
                  @if (maintenanceTypes?.length) {
                    {{ maintenanceTypes }}
                  } @else {
                    {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.EMPTY' | translate }}
                  }
                </palantir-text>
              </palantir-input>

              <palantir-input [label]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.COMPANY' | translate">
                @if (isViewMode) {
                  <palantir-text type="title">
                    @if (warranty.company?.id) {
                      {{ warranty?.company?.name }}
                    } @else {
                      {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.NO_COMPANY' | translate }}
                    }
                  </palantir-text>
                } @else {
                  <palantir-select
                    [placeholder]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.SEARCH_BY_NAME' | translate"
                    [emptyState]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.NO_SEARCH_RESULT' | translate"
                    [control]="forms[i] | getControl: 'company'"
                    [mapper]="mapOption.bind(this)"
                    [search]="search.bind(this)"
                  >
                  </palantir-select>
                }
              </palantir-input>

              <palantir-input [label]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.DESCRIPTION' | translate">
                @if (isViewMode) {
                  <palantir-text type="title">
                    {{ warranty.description }}
                  </palantir-text>
                } @else {
                  <textarea
                    class="w-full"
                    [formControl]="forms[i] | getControl: 'description'"
                    cdkAutosizeMinRows="2"
                    cdkAutosizeMaxRows="5"
                    [placeholder]="'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.INPUTS.DESCRIPTION' | translate"
                    maxlength="2000"
                  ></textarea>
                }
                <palantir-input-error>
                  @if (forms[i].get('description')?.hasError('required')) {
                    <palantir-text type="negative" size="xs">
                      {{ 'TAB_WARRANTIES_EQUIPMENT.WARRANTIES.ERRORS.REQUIRED' | translate }}
                    </palantir-text>
                  }
                </palantir-input-error>
              </palantir-input>
            </div>
          </div>
          <div class="flex items-center justify-end gap-3">
            @if (isViewMode) {
              @if (hasEditWarrantyPermission) {
                <palantir-button
                  size="2xs"
                  variant="negative"
                  theme="outline"
                  layout="prefix"
                  icon="remove-outline"
                  (click)="removeWarranty(warranty)"
                >
                  {{ 'TAB_WARRANTIES_EQUIPMENT.BUTTON.REMOVE' | translate }}
                </palantir-button>
                <palantir-button size="2xs" theme="outline" layout="prefix" icon="edit-outline" (click)="toggleEdit(i)">
                  {{ 'TAB_WARRANTIES_EQUIPMENT.BUTTON.EDIT' | translate }}
                </palantir-button>
              }
            } @else {
              <palantir-button
                size="2xs"
                variant="negative"
                theme="outline"
                layout="prefix"
                icon="close-outline"
                (click)="cancelEdit()"
              >
                {{ 'TAB_WARRANTIES_EQUIPMENT.BUTTON.CANCEL' | translate }}
              </palantir-button>
              <palantir-button
                size="2xs"
                theme="outline"
                layout="prefix"
                icon="check-outline"
                (click)="saveWarranty(forms[i])"
                [attr.disabled]="forms[i].invalid"
              >
                {{ 'TAB_WARRANTIES_EQUIPMENT.BUTTON.SAVE' | translate }}
              </palantir-button>
            }
          </div>
        </palantir-accordion>
      }
    </div>
  } @else {
    <div class="w-full h-[400px] flex flex-col items-center justify-center">
      <div class="flex flex-col items-center gap-3 mt-3 mb-3">
        <palantir-icon style="font-size: 150px" name="warranty-gradient"></palantir-icon>
        <palantir-text type="title" size="lg">
          {{ 'TAB_WARRANTIES_EQUIPMENT.NO_RESULTS.TITLE' | translate }}
        </palantir-text>
        <palantir-text type="description" size="xs">
          {{ 'TAB_WARRANTIES_EQUIPMENT.NO_RESULTS.DESCRIPTION' | translate }}
        </palantir-text>
      </div>
      @if (hasCreateWarrantyPermission) {
        <palantir-button (click)="openDialog()" theme="outline" layout="prefix" icon="add-outline">
          {{ 'TAB_WARRANTIES_EQUIPMENT.BUTTON.ADD' | translate }}</palantir-button
        >
      }
    </div>
  }
</ng-scrollbar>
